<!-- Agregamos min-h-0 y flex-col para controlar el crecimiento -->
<div class="h-full flex flex-col min-h-0 overflow-hidden">
  <!-- CABECERA: En móvil reducimos textos y márgenes -->
  <div class="shrink-0 mb-2 sm:mb-4">
    <div class="flex flex-col sm:flex-row gap-2 items-stretch sm:items-center">
      <app-input-buscador
        placeholder="Buscar..."
        [(valor)]="busqueda"
        class="flex-1"
        (presionaEnter)="onBuscar()"
      />
      <app-button
        label="Nuevo"
        icon="bi bi-plus"
        variant="primary"
        (onClick)="modal_crear.set(true)"
        class="w-full sm:w-auto text-sm py-2!"
      />
    </div>
  </div>

  <!-- CATEGORÍAS + TIPO: Más compactas en móvil -->
  <div class="shrink-0 mb-2 sm:mb-4 flex gap-2 items-start">
    <div class="flex gap-1.5 overflow-x-auto pb-1 no-scrollbar flex-1">
      <button
        class="px-3 py-1.5 rounded-lg text-xs sm:text-sm font-semibold whitespace-nowrap"
        [ngClass]="{
          'bg-blue-600 text-white': categoria_seleccionada() === null,
          'bg-slate-100 text-slate-700': categoria_seleccionada() !== null,
        }"
        (click)="filtrarPorCategoria(null)"
      >
        Todos
      </button>
      @for (categoria of categorias(); track categoria.id) {
        <button
          class="px-3 py-1.5 rounded-lg text-xs sm:text-sm font-semibold whitespace-nowrap transition"
          [ngClass]="{
            'bg-blue-600 text-white': categoria_seleccionada() === categoria.id,
            'bg-slate-100 text-slate-700': categoria_seleccionada() !== categoria.id,
          }"
          (click)="filtrarPorCategoria(categoria.id)"
        >
          {{ categoria.nombre }}
        </button>
      }
    </div>
    <app-select
      [options]="opcionesTipoProducto"
      [(value)]="tipo_producto_seleccionado"
      (onChange)="filtrarPorTipoProducto($event)"
      placeholder="Tipo"
      styleClass="text-xs sm:text-sm w-36 sm:w-40 shrink-0"
    />
  </div>

  <!-- TABLA: El área que debe crecer -->
  <!-- Usamos flex-1 para que tome todo el espacio sobrante -->
  <div
    class="flex-1 min-h-0 bg-white border border-slate-200 rounded-xl overflow-hidden flex flex-col"
  >
    <div class="flex-1 overflow-auto">
      <app-tabla
        [columnas]="columnasTabla"
        [accionesTemplate]="accionesTemplate"
        [datos]="paginacion()?.data || []"
      />
    </div>
  </div>

  <!-- PAGINADOR: Siempre pegado abajo, sin importar el scroll de la tabla -->
  @if (paginacion() != null) {
    <div class="shrink-0">
      <app-paginacion
        [items]="paginacion()!.data"
        [itemsPorPagina]="paginacion()!.size"
        [totalItems]="paginacion()!.total"
        (paginaCambiada)="cambiarPagina($event)"
      />
    </div>
  }
</div>
<!-- --- MODALES (Se mantienen igual fuera del flujo principal) --- -->

<app-dialog
  header="Crear producto"
  [modal]="true"
  [(visible)]="modal_crear"
  (onHide)="modal_crear.set(false)"
  size="md"
>
  @if (modal_crear()) {
    <app-crear-producto
      [categorias]="categorias()"
      (cerrar)="modal_crear.set(false)"
      (crear)="onCrear($event)"
    />
  }
</app-dialog>

<app-dialog
  header="Editar producto"
  [modal]="true"
  [(visible)]="modal_editar"
  (onHide)="modal_editar.set(false)"
  size="3xl"
>
  @if (modal_editar() && productoSeleccionado()) {
    <app-editar-producto
      [producto]="productoSeleccionado()!"
      [categorias]="categorias()"
      (cerrar)="onCerrarEditar($event)"
    />
  }
</app-dialog>

<app-dialog
  header="Eliminar producto"
  [modal]="true"
  [(visible)]="modal_eliminar"
  (onHide)="modal_eliminar.set(false)"
  size="xs"
>
  <app-modal-confirmacion
    mensaje="¿Estás seguro que deseas eliminar al producto?"
    textoCancel="Cancelar"
    textoConfirm="Si, eliminar"
    (confirmar)="eliminar()"
    (cancelar)="cerrarModalEliminar()"
  />
</app-dialog>

<app-dialog
  header="Ver producto"
  [modal]="true"
  [(visible)]="modal_ver"
  (onHide)="modal_ver.set(false)"
  size="md"
>
  @if (modal_ver() && productoSeleccionado()) {
    <app-ver-producto [producto]="productoSeleccionado()!" (cerrar)="modal_ver.set(false)" />
  }
</app-dialog>

<!-- --- TEMPLATES (Se mantienen igual) --- -->

<ng-template #categoriaTemplate let-row>
  @if (row.categoria == undefined || row.categoria == null || row.categoria.nombre.length === 0) {
    SIN CATEGORÍA
  } @else {
    {{ row.categoria.nombre | uppercase }}
  }
</ng-template>

<ng-template #precioTemplate let-row>
  {{ row.precio_venta_original ?? row.precio_venta | currency: 'PEN' : 'S/.' }}
  @if (
    row.descuento_campana_id &&
    row.precio_venta_final != null &&
    row.precio_venta_final < (row.precio_venta_original ?? row.precio_venta)
  ) {
    <span
      class="bg-purple-100 text-purple-700 text-[10px] px-1.5 py-0.5 rounded-full font-medium ml-1"
      appTooltip="Precio con descuento de campaña: {{
        row.precio_venta_final | currency: 'PEN' : 'S/.'
      }}"
      tooltipPosition="top"
      >campaña</span
    >
  }
</ng-template>

<ng-template #precioBaseTemplate let-row>
  {{ row.precio_base | currency: 'PEN' : 'S/.' }}
</ng-template>

<ng-template #tipoTemplate let-row>
  @if (row.producto_servicio != null && row.producto_servicio != undefined) {
    <div class="bg-purple-100 rounded-lg sm:rounded-2xl text-center py-1 px-2">
      <span class="text-purple-600 font-semibold text-xs sm:text-sm">Servicio</span>
    </div>
  } @else {
    <div class="bg-blue-100 rounded-lg sm:rounded-2xl text-center py-1 px-2">
      <span class="text-blue-600 font-semibold text-xs sm:text-sm">Producto</span>
    </div>
  }
</ng-template>

<ng-template #stockTemplate let-row>
  @switch (true) {
    @case (row.stock_sucursal.controlar_stock == false) {
      <div class="bg-gray-100 rounded-lg sm:rounded-2xl text-center py-1 px-2">
        <span class="text-gray-600 font-semibold text-xs sm:text-sm">Sin control</span>
      </div>
    }
    @case (!row.stock_sucursal.stock && row.controlar_stock == true) {
      <div class="bg-gray-100 rounded-lg sm:rounded-2xl text-center py-1 px-2">
        <span class="text-gray-600 font-semibold text-xs sm:text-sm">Agotado</span>
      </div>
    }
    @case (row.stock_sucursal.stock < 10) {
      <div class="bg-red-100 rounded-lg sm:rounded-2xl text-center py-1 px-2">
        <span class="text-red-600 font-semibold text-xs sm:text-sm">{{
          row.stock_sucursal.stock
        }}</span>
      </div>
    }
    @case (row.stock_sucursal.stock < 20) {
      <div class="bg-yellow-100 rounded-lg sm:rounded-2xl text-center py-1 px-2">
        <span class="text-yellow-600 font-semibold text-xs sm:text-sm">{{
          row.stock_sucursal.stock
        }}</span>
      </div>
    }
    @default {
      <div class="bg-green-100 rounded-lg sm:rounded-2xl text-center py-1 px-2">
        <span class="text-green-600 font-semibold text-xs sm:text-sm">{{
          row.stock_sucursal.stock
        }}</span>
      </div>
    }
  }
  @if (row.stock_sucursal.id === 0 && row.stock_sucursal.sucursal_id !== 0) {
    <span
      class="text-[10px] text-amber-500 block mt-0.5 italic"
      appTooltip="Configuración heredada de sucursal principal. Edita el producto para personalizarla."
      tooltipPosition="bottom"
      >heredado</span
    >
  }
</ng-template>

<ng-template #activoTemplate let-row>
  @if (row.activo) {
    <div class="bg-green-100 rounded-lg sm:rounded-2xl text-center py-1 px-2">
      <span class="text-green-600 font-semibold text-xs sm:text-sm">Activo</span>
    </div>
  } @else {
    <div class="bg-red-100 rounded-lg sm:rounded-2xl text-center py-1 px-2">
      <span class="text-red-600 font-semibold text-xs sm:text-sm">Inactivo</span>
    </div>
  }
</ng-template>

<ng-template #accionesTemplate let-row>
  <div class="flex gap-1 sm:gap-2">
    <app-button
      icon="bi bi-eye"
      variant="secondary"
      size="sm"
      rounded
      (onClick)="onVer(row)"
      appTooltip="Ver"
      tooltipPosition="top"
    />
    <app-button
      icon="bi bi-pencil"
      variant="info"
      size="sm"
      rounded
      (onClick)="onEditar(row)"
      appTooltip="Editar"
      tooltipPosition="top"
    />
    <app-button
      icon="bi bi-printer"
      variant="secondary"
      size="sm"
      rounded
      (onClick)="imprimirEtiqueta(row)"
      appTooltip="Imprimir etiqueta"
      tooltipPosition="top"
    />
    <app-button
      icon="bi bi-trash"
      variant="danger"
      size="sm"
      rounded
      (onClick)="solicitarEliminar(row)"
      appTooltip="Eliminar"
      tooltipPosition="top"
    />
  </div>
</ng-template>
